module.exports = __webpack_public_path__ + "84ce6c965297139c6d727158ccf43abd.png";